__turbopack_context__.v({
  "bgVectors": "EngineeringSection-module__tEPoTW__bgVectors",
  "contentWrapper": "EngineeringSection-module__tEPoTW__contentWrapper",
  "featureDescription": "EngineeringSection-module__tEPoTW__featureDescription" + " " + __turbopack_context__.i(515534)["cardBody"],
  "featureItem": "EngineeringSection-module__tEPoTW__featureItem",
  "featureTitle": "EngineeringSection-module__tEPoTW__featureTitle" + " " + __turbopack_context__.i(515534)["cardTitle"],
  "header": "EngineeringSection-module__tEPoTW__header" + " " + __turbopack_context__.i(515534)["sectionTextBlock"],
  "heading": "EngineeringSection-module__tEPoTW__heading" + " " + __turbopack_context__.i(515534)["sectionHeading"],
  "leftColumn": "EngineeringSection-module__tEPoTW__leftColumn",
  "rightColumn": "EngineeringSection-module__tEPoTW__rightColumn",
  "ringImage": "EngineeringSection-module__tEPoTW__ringImage",
  "section": "EngineeringSection-module__tEPoTW__section",
});
